export function getFileExtension(f:File): string{
    var res:string='';

    if(f){
        res=f.name.slice(f.name.lastIndexOf(".")).replace('.','');
    }

    return res;
}
